import {getCaseDetails, getEnumDict} from 'api/common';

const app = {
  state: {
    caseDetails: {},
    statusDic: null,
  },

  mutations: {
    SET_DETAILS: (state, details) => {
      state.caseDetails = details;
    },
    SET_STATUSDIC: (state, statusDic) => {
      state.statusDic = statusDic;
    }
  },
  actions: {
    getCaseDetails({commit}, caseTempNo) {
      return new Promise((resolve, reject) => {
        getCaseDetails(caseTempNo).then(res => {
          if (res.type === 'success') {
            commit('SET_DETAILS', res.data);
            setTimeout(function () {
              resolve();
            }, 5)
          } else {
            reject(res);
          }
        })
      });
    },
    setStatusDic({commit, state}) {
      if(state.statusDic) return;
      return new Promise((resolve, reject) => {
        getEnumDict('caseStatus').then(function (res) {
          if (res.type === 'success') {
            var statusDic = {};
            res.data.forEach(function (item) {
              statusDic[item.value] = item.text
            });
            commit('SET_STATUSDIC', statusDic);
            resolve(res);
          } else {
            reject(res);
          }
        })
      })
    }
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js